<div class="d-flex flex-column position-relative download-modal">
    <button
        mat-icon-button
        mat-dialog-close
        aria-label="Close download confirmation payment"
        class="position-absolute end-0 top-0 p-0"
    >
        <mat-icon>close</mat-icon>
    </button>
    <form [formGroup]="fileFormatForm" (submit)="downloadFiles()">
        <div class="mat-headline-4 text-center m-0">Download</div>
        <mat-dialog-content>
            <div class="d-flex flex-column form-container p-3 align-items-center">
                @if (data.paymentsIDs.length) {
                    <div class="flex-row mat-headline-6 title">
                        <span class="primary-text">{{ data.paymentsIDs.length || 0 }} items selected</span>
                    </div>
                    <div class="d-flex flex-column mb-4">
                        <div class="mat-caption m-2">SELECT FORMAT:</div>
                        <div class="d-flex flex-row">
                            <mat-radio-group
                                formControlName="fileFormat"
                                aria-labelledby="example-radio-group-label"
                                class="example-radio-group"
                            >
                                @for (format of fileFormats; let formatIndex = $index; track formatIndex) {
                                    <mat-radio-button class="example-radio-button m-2" [value]="format">
                                        Download
                                        <span class="fw-bold">.{{ format }}</span>
                                    </mat-radio-button>
                                }
                            </mat-radio-group>
                        </div>
                    </div>
                } @else {
                    <app-date-range
                        (eventOnChangeRange)="eventOnChangeRange($event)"
                        (eventInitialRange)="eventOnChangeRange($event)"
                        [isLoading]="isDownloading"
                        [maxDate]="maxDate"
                    />
                    <div class="label-date-range">Download up 3 months time range invoices .XLSX format.</div>
                }
            </div>
        </mat-dialog-content>
        <mat-dialog-actions [align]="'end'">
            <button matButton="outlined" appMatStrokedButtonBorder mat-dialog-close color="primary" type="button">
                CANCEL
            </button>
            <button matButton="filled" type="submit" color="primary">
                {{ isDownloading ? 'DOWNLOADING' : 'DOWNLOAD' }}
                @if (isDownloading) {
                    <mat-icon class="ms-2 spinner-icon" iconPositionEnd>
                        <mat-spinner diameter="16" />
                    </mat-icon>
                }
            </button>
        </mat-dialog-actions>
    </form>
</div>
